import { IconCross, IconDollar } from '../ui'
import uniqid from 'uniqid'
import { Form } from 'react-bootstrap'
import { IFilterNumberRange } from '../../types'

export const FilterNumberRange = (props: IFilterNumberRange) => {
	const {
		attr,
		value,
		setValue,
		label,
		placeholder,
		styles = {},
		isClearable = false,
		isDisabled = false,
		isIconRightVisible = false,
		iconRight = <IconDollar size={20} />
	} = props
	const key = uniqid()
	//TODO: check the className-s [without extra spaces] for cases 'isClearable' and 'isIconRightVisible'
	return (
		<div className="filter-input-cont" style={styles}>
			{label ? <Form.Label className="text-dark" htmlFor={`input-${key}-1`}>{label}</Form.Label> : null}

			<div style={{ display: 'flex', flexFlow: 'row nowrap', }}>
				<div className={'src-form position-relative'}>
					<input
						type="text"
						id={`input-${key}-1`}
						/*className="form-control form-control--without-icon-right"*/
						className="form-control"
						autoComplete={'off'}
						{...attr}
						placeholder={placeholder ?? ''}
						disabled={isDisabled}
						value={value[0] ?? ''}
						onChange={(event) => setValue([event.target.value, value[1]])}
					/>

					<div className={'input-buttons bg-transparent position-absolute top-50 translate-middle-y'}>
						{!isDisabled && isClearable && value?.[0]?.toString()?.length > 0 ? (
							<i className="icon-cross" onClick={(event) => setValue(['', value[1]])}>
								<IconCross/>
							</i>
						) : null}

						{isIconRightVisible ? (
							<>
								<span className="indicator-separator"></span>

								<i className="icon-right">
									{iconRight}
								</i>
							</>
						) : null}
					</div>
				</div>
				&nbsp;
				<div className={'src-form position-relative'}>
					<input
						type="text"
						id={`input-${key}-2`}
						/*className="form-control form-control--without-icon-right"*/
						className="form-control"
						autoComplete={'off'}
						{...attr}
						placeholder={placeholder ?? ''}
						disabled={isDisabled}
						value={value[1] ?? ''}
						onChange={(event) => setValue([value[0], event.target.value])}
					/>

					<div className={'input-buttons bg-transparent position-absolute top-50 translate-middle-y'}>
						{!isDisabled && isClearable && value?.[1]?.toString()?.length > 0 ? (
							<i className="icon-cross" onClick={(event) => setValue([value[0], ''])}>
								<IconCross/>
							</i>
						) : null}

						{isIconRightVisible ? (
							<>
								<span className="indicator-separator"></span>

								<i className="icon-right">
									{iconRight}
								</i>
							</>
						) : null}
					</div>
				</div>
			</div>
		</div>
	)
}